import { Check } from "@mui/icons-material";
import { Box, Collapse, Grid, Typography, useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getModuleNameInArea,
  getPatientTrainFrom,
  getReceptionStatusOfPatient,
  inquiryPatient,
  setPatientTrainFrom,
  setReceptionStatusOfPatient,
} from "../../api/area";
import { getPatientReport } from "../../api/jahadgar";
import CalendarIcon from "../../assets/SVG/calendarIcon";
import ClockIcon from "../../assets/SVG/clockIcon";
import DownArrow from "../../assets/SVG/downArrow";
import MedicalRecordsIcon from "../../assets/SVG/medicalRecordsIcon";
import ProfilePatientIcon from "../../assets/SVG/profilePatientIcon";
import Qarbal from "../../components/areaManager/parvandeh/qarbal/qarbal";
import Referral from "../../components/areaManager/parvandeh/referral";
import DrugInParvande from "../../components/areaManager/sidebarArea/drug/drugInParvande";
import CustomizedHook from "../../components/project/autocomplatePro";
import { InputCreateProject } from "../../components/project/createProjectPop";
import { CheckBoxBranch } from "../../components/signin/chekboxListBranch";
import ErjaParvandeh from "../leaderGroup/erjaParvandeh";
import TableQarbalParvande from "../../tableQarbalParvande";
import ModuleSection from "./ModuleSection";

export function LabelParvandeh({ label, value }) {
  return (
    <Box width="calc(100% - 20px )">
      <Typography fontWeight={"bold"}>{label}</Typography>
      <Box
        border="solid 1px #D0D0D0"
        color="#3A3939"
        p="10px"
        borderRadius="10px"
        width="100%"
        fontSize="14px"
      >
        {value}
      </Box>
    </Box>
  );
}

export default function Parvandeh() {
  const [data, setData] = useState();
  const [CollapseQarbal, setCollapseQarbal] = useState();
  const [dataQarbalTable, setDataQarbalTable] = useState([]);
  const [moduleInArea, setModuleInArea] = useState();
  const [selectedModule, setSelectedModule] = useState("amozesh");
  const [params] = useSearchParams();

  const [dataQarbal, setDataQarbal] = useState({
    height: "",
    weight: "",
    // shepesh: "",
    recvCulturePackage: false,
    recvShampoo: false,
    description: "",
    bmi: "",
  });

  useEffect(() => {
    inquiryPatient(params.get("areaId"), {
      identifier: params.get("patientIdentifier"),
      identifierType: params.get("patientIdentifierType"),
    })
      .then((x) => {
        setData(x);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (dataQarbal?.weight && dataQarbal?.height) {
      setDataQarbal({
        ...dataQarbal,
        bmi: parseInt(
          dataQarbal?.weight /
            ((dataQarbal?.height * dataQarbal?.height) / 10000),
        ),
      });
    }
  }, [dataQarbal?.weight, dataQarbal?.height]);

  const fetchTabs = useCallback(() => {
    setSelectedModule(decodeURIComponent(params.get("tabName")));
    let areaCache = null;
    if (localStorage.getItem("area_data_" + params.get("areaId")) !== null) {
      areaCache = JSON.parse(
        localStorage.getItem("area_data_" + params.get("areaId")),
      );

      if (areaCache.expire_at > Date.now() && areaCache?.tabs) {
        setModuleInArea(areaCache?.tabs);
        return;
      } else if (areaCache.expire_at < Date.now()) {
        localStorage.removeItem("area_data_" + params.get("areaId"));
        areaCache = null;
      }
    }

    getModuleNameInArea(params.get("areaId"))
      .then((x) => {
        if (areaCache !== null) areaCache.tabs = x;
        else {
          areaCache = {
            tabs: x,
            expire_at: Date.now() + 86400000,
          };
        }
        localStorage.setItem(
          "area_data_" + params.get("areaId"),
          JSON.stringify(areaCache),
        );
        setModuleInArea(x);
      })
      .catch(() => {});
  }, [localStorage, params]);

  useEffect(() => {
    fetchTabs();
  }, []);

  useEffect(() => {
    if (CollapseQarbal) {
      getPatientTrainFrom(params.get("areaId"), params.get("patientId"))
        .then((x) => {
          setDataQarbalTable([x]);
        })
        .catch(() => {});
    }
  }, [CollapseQarbal]);

  const [receptionStatus, setReceptionStatus] = useState();
  const [loadingReception, setLoadingReception] = useState(false);
  const md = useMediaQuery("(max-width:450px)");

  useEffect(() => {
    if (
      params.get("areaId") &&
      params.get("moduleId") &&
      params.get("patientId")
    ) {
      getReceptionStatusOfPatient(
        params.get("areaId"),
        params.get("moduleId"),
        params.get("patientId"),
      ).then((res) => {
        setReceptionStatus(res);
      });
    }
  }, []);

  return (
    <>
      <Box p="20px" overflow={md ? "auto" : "unset"}>
        <Box
          bgcolor="white"
          width="calc(100vw - 40px )"
          height={md ? "unset" : "calc(100vh - 40px)"}
          borderRadius="17px"
          display="flex"
          flexDirection={md ? "column" : "row"}
          sx={{ overflow: md ? "auto" : "hidden" }}
        >
          <Box
            sx={
              md
                ? {}
                : {
                    overflow: "auto",
                    "::-webkit-scrollbar": {
                      display: "none",
                    },
                  }
            }
            width={md ? "100%" : "calc(25% - 20px)"}
            py="20px"
          >
            <Box
              display="flex"
              pb={md ? "0px" : "20px"}
              borderBottom={"solid 3px #D6DAFF"}
              justifyContent={"center"}
              alignItems="center"
            >
              <Grid
                display={"flex"}
                flexDirection={md ? "row" : "column"}
                alignItems={"center"}
                width={"fit-content"}
              >
                <Box
                  p={md ? "10px" : "20px"}
                  borderRadius="50%"
                  border={md ? "unset" : "solid 2px var(--emr-darkblue)"}
                >
                  <ProfilePatientIcon />
                </Box>
                <Grid
                  mt={md ? "0px" : "20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"10px"}
                >
                  <Box color="#E2445C">{`شماره پرونده : ${data?.patientNo}`}</Box>
                  {md && (
                    <>
                      <Box gap="10px" display="flex" alignItems={"center"}>
                        <CalendarIcon />
                        <Typography>{`تاریخ مراجعه بیمار: ${
                          data?.createdAt?.split("-", 2)[0]
                        }`}</Typography>
                      </Box>
                      <Box gap="10px" display="flex" alignItems={"center"}>
                        <ClockIcon />
                        <Typography>{`ساعت مراجعه بیمار: ${
                          data?.createdAt?.split("-", 2)[1]
                        }`}</Typography>
                      </Box>
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>

            <Box
              display="grid"
              gap="20px"
              justifyContent={"center"}
              py={md ? 0 : "20px"}
              pt={md ? "10px" : undefined}
            >
              <Box
                display="flex"
                bgcolor="#42C3CF"
                p="10px"
                height="30px"
                color="white"
                borderRadius="11px"
                alignItems={"center"}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  getPatientReport(data?.id)
                    .then((x) => {
                      const blob = new Blob([x], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `گزارش پرونده ${data?.name}`;
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                      window.URL.revokeObjectURL(url);
                    })
                    .catch(() => {});
                }}
              >
                <MedicalRecordsIcon size="0.4" color="white" />
                <Typography>مشاهده پرونده پزشکی</Typography>
              </Box>
              {receptionStatus !== undefined && !receptionStatus && (
                <>
                  <Box
                    display="flex"
                    bgcolor="#42C3CF"
                    p="10px"
                    justifyContent={"center"}
                    height="30px"
                    color="white"
                    borderRadius="11px"
                    alignItems={"center"}
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      if (loadingReception) return;
                      setLoadingReception(true);
                      setReceptionStatusOfPatient(
                        params.get("areaId"),
                        params.get("moduleId"),
                        params.get("patientId"),
                        true,
                      )
                        .then(() => {
                          toast.success("ثبت ورود با موفقیت انجام شد");
                          setReceptionStatus(true);
                        })
                        .finally(() => setLoadingReception(false));
                    }}
                  >
                    <Check size="0.4" color="white" />
                    {loadingReception && (
                      <Typography>در حال ثبت ورود</Typography>
                    )}
                    {!loadingReception && <Typography>ثبت ورود</Typography>}
                  </Box>
                </>
              )}

              <LabelParvandeh label="نام و نام خانوادگی" value={data?.name} />
              <LabelParvandeh label="نام پدر" value={data?.fatherName} />
              <LabelParvandeh
                label="تاریخ تولد"
                value={data?.birthDate?.split("-", 2)[0]}
              />
              <LabelParvandeh label="کد ملی" value={data?.identifier} />
              <LabelParvandeh
                label={
                  data?.ageType === "ADULT"
                    ? "شماره تلفن "
                    : "شماره تلفن والدین"
                }
                value={data?.phone}
              />
              <LabelParvandeh
                label="نوع بیمه"
                value={
                  data?.insurance === "TAKMIL"
                    ? "تکمیلی"
                    : data?.insurance === "MILITARY"
                      ? "نیروهای مسلح"
                      : data?.insurance === "TAMIN"
                        ? "تامین اجتماعی"
                        : data?.insurance === "SALAMAT"
                          ? "سلامت"
                          : "ندارد "
                }
              />
            </Box>
          </Box>

          <Grid
            width={md ? "100%" : "150px"}
            display={"flex"}
            flexDirection={md ? "row" : "column"}
            gap={md ? "15px" : "unset"}
            borderRight="solid 3px #D6DAFF"
            borderLeft="solid 3px #D6DAFF"
            sx={
              md
                ? {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    overflow: "auto",
                  }
                : {
                    overflow: "auto",
                    "::-webkit-scrollbar": {
                      display: "none",
                    },
                  }
            }
          >
            <ModuleSection
              title={"آموزش"}
              onClick={() => setSelectedModule("amozesh")}
              className={"icon-classroom-1"}
              itemKey={"amozesh"}
              selectedModule={selectedModule}
            />
            {moduleInArea &&
              Object.entries(moduleInArea)?.map((x, index) => (
                <ModuleSection
                  key={index}
                  title={x[0]}
                  selectedModule={selectedModule}
                  onClick={() => setSelectedModule(x[0])}
                  className={x[1]}
                  itemKey={x[0]}
                />
              ))}
            <ModuleSection
              title={"داروخانه"}
              itemKey={"drug"}
              onClick={() => setSelectedModule("drug")}
              className={"icon-pharmacy"}
              selectedModule={selectedModule}
            />
            <ModuleSection
              title={"ارجاع"}
              itemKey={"erja"}
              onClick={() => setSelectedModule("erja")}
              className={"icon-pharmacy"}
              selectedModule={selectedModule}
            />
          </Grid>

          <Box
            width={md ? "100%" : "calc(60% - 40px)"}
            px="20px"
            mt={md ? "20px" : "unset"}
          >
            {!md && (
              <Box display="flex" p="15px">
                <Box gap="10px" display="flex" alignItems={"center"}>
                  <CalendarIcon />
                  <Typography>{`تاریخ مراجعه بیمار: ${
                    data?.createdAt?.split("-", 2)[0]
                  }`}</Typography>
                </Box>
                <Box mr="20px" gap="10px" display="flex" alignItems={"center"}>
                  <ClockIcon />
                  <Typography>{`ساعت مراجعه بیمار: ${
                    data?.createdAt?.split("-", 2)[1]
                  }`}</Typography>
                </Box>
              </Box>
            )}

            {selectedModule === "amozesh" && (
              <Box sx={{ height: "80vh", overflowY: "auto" }}>
                <Typography
                  mt="20px"
                  fontWeight="bold"
                  color="var(--emr-darkblue)"
                >
                  {data?.ageType === "ADULT"
                    ? "آموزش بزرگسالان"
                    : "آموزش کودکان"}
                </Typography>
                <Box
                  onClick={() => setCollapseQarbal(!CollapseQarbal)}
                  bgcolor="#EFF1F7"
                  borderRadius={"7px"}
                  p="10px"
                  display="flex"
                  justifyContent={"space-between"}
                  alignItems="center"
                  sx={{ cursor: "pointer" }}
                  mt="20px"
                >
                  <Typography color="var(--emr-darkblue)">
                    {data?.ageType === "ADULT"
                      ? "اطلاعات غربالگری بزرگسالان"
                      : "اطلاعات غربالگری کودکان"}
                  </Typography>
                  <DownArrow transform={CollapseQarbal} />
                </Box>
                <Collapse in={CollapseQarbal} timeout="auto">
                  <Box mt="-5px" bgcolor="#EFF1F7" p="10px">
                    <Box display="flex" flexWrap="wrap" gap="20px">
                      <InputCreateProject
                        placeholder={"اندازه قد بیمار بر حسب سانتی متر"}
                        label="قد"
                        value={dataQarbal?.height}
                        onChange={(e) =>
                          setDataQarbal({
                            ...dataQarbal,
                            height: e.target.value.replace(/\D/g, ""),
                          })
                        }
                      />
                      <InputCreateProject
                        placeholder={"اندازه وزن بیمار بر حسب کیلوگرم"}
                        label="وزن"
                        value={dataQarbal?.weight}
                        onChange={(e) =>
                          setDataQarbal({
                            ...dataQarbal,
                            weight: e.target.value.replace(/\D/g, ""),
                          })
                        }
                      />
                      <InputCreateProject
                        placeholder={"چیزی بنویسید"}
                        label="BMI"
                        value={parseInt(
                          dataQarbal?.weight /
                            ((dataQarbal?.height * dataQarbal?.height) / 10000),
                        )}
                      />
                      <Box sx={{ overflow: "hidden" }} width="250px">
                        <CustomizedHook
                          placeholder={"انتخاب کنید."}
                          label="شپش"
                          options={[
                            { title: "normal", name: "NORMAL" },
                            { title: "nit", name: "NIT" },
                            { title: "شپش بالغ", name: "BALEGH" },
                          ]}
                          value={dataQarbal?.shepesh}
                          onChange={(_, newValue) => {
                            setDataQarbal({
                              ...dataQarbal,
                              shepesh: newValue.name,
                            });
                          }}
                        />
                      </Box>
                      <InputCreateProject
                        placeholder={"چیزی بنویسید"}
                        label="توضیحات"
                        value={dataQarbal?.description}
                        onChange={(e) =>
                          setDataQarbal({
                            ...dataQarbal,
                            description: e.target.value,
                          })
                        }
                      />
                      <Box mt="10px">
                        <CheckBoxBranch
                          onChange={(e) =>
                            setDataQarbal({
                              ...dataQarbal,
                              recvCulturePackage: e.target.checked,
                            })
                          }
                          width={"160px"}
                          label="بسته فرهنگی"
                        />
                        <CheckBoxBranch
                          onChange={(e) =>
                            setDataQarbal({
                              ...dataQarbal,
                              recvShampoo: e.target.checked,
                            })
                          }
                          width={"100px"}
                          label="شامپو"
                        />
                      </Box>
                    </Box>
                    <Box mt="10px" display="flex" justifyContent="end">
                      <botton
                        style={{
                          border: "none",
                          backgroundColor: "var(--emr-darkblue)",
                          color: "white",
                          padding: "5px 40px",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setPatientTrainFrom(
                            params.get("areaId"),
                            data?.id,
                            dataQarbal,
                          )
                            .then(() => {
                              toast.success("فرم با موفقیت ثبت گردید");
                              getPatientTrainFrom(
                                params.get("areaId"),
                                params.get("patientId"),
                              )
                                .then((x) => setDataQarbalTable([x]))
                                .catch(() => {});
                            })
                            .catch(() => {});
                        }}
                      >
                        ثبت
                      </botton>
                    </Box>
                    {dataQarbalTable?.length >= 1 && (
                      <TableQarbalParvande rowData={dataQarbalTable} />
                    )}
                  </Box>
                </Collapse>
                <Referral amozesh data={data} />
              </Box>
            )}
            {selectedModule &&
              selectedModule !== "amozesh" &&
              selectedModule !== "drug" &&
              selectedModule !== "erja" && (
                <Qarbal
                  dataUser={data}
                  selectedModuleTab={selectedModule}
                  selectedModule={params.get("moduleId")}
                  areaId={params.get("areaId")}
                />
              )}
            {selectedModule === "drug" && (
              <DrugInParvande
                moduleId={params.get("moduleId")}
                areaId={params.get("areaId")}
                parvande
              />
            )}
            {selectedModule === "erja" && (
              <ErjaParvandeh
                areaId={params.get("areaId")}
                patientId={params.get("patientId")}
                parvande
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
}
